import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { UniAuthFacade } from '../modules/uni-auth/shared/uni-auth.facade';
import { DateUtils } from '../utils';

@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
  timezone = this.uniAuthFacade.user.timezone;

  constructor(private uniAuthFacade: UniAuthFacade) {
    super('en-GB');
  }

  transform(date: string, format = DateUtils.Format.defaultDateTime): any {
    return DateUtils.display(date, format, this.timezone);
  }
}
